<!-- <router-outlet></router-outlet> -->
<div id="all" *ngIf="!export && datas" [class]="'status-'+status" [class.home]="homeStitch"
  [class.flag_keyboard]="keyboard" [class.empty_pseudo]="!pseudo" [class.dragging]="dragging" [class.paused]="paused"
  (window:resize)="onResize($event)" (click)="onClick()" (mousemove)="mousemove.next($event)"
  (mouseup)="mouseup.next($event)" (dragstart)="preventDefault($event)" (drop)="preventDefault($event)">
  <div class="filter" [style.filter]="filter">

    <canvas #canvas id="canvas" [class.hide]="status == 'conclusions'"></canvas>
    <canvas #canvasImg id="canvasImg" width="101" height="101"></canvas>

    <ng-container *ngIf="startDone && !background">
      <div class="langs">
        <a *ngIf="lang == 0" (click)="onLang(1)">English</a>
        <a *ngIf="lang == 1" (click)="onLang(0)">Français</a>
      </div>

      <div class="title shadow" [innerHTML]="title"></div>
      <div class="textarea">
        <div [innerHTML]="stitch?.text"></div>
        <div class="keyboard_screen" *ngIf="stitch?.hasFlag('keyboard')">
          <!-- <div class="instruction">Quel est votre prénom ?</div> -->
          <div class="pseudo" [innerHTML]="pseudo"></div>
        </div>
        <a class="back" (click)="onBack()" *ngIf="debug">
          <svg class="arrow" version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50"
            style="enable-background:new 0 0 50 50;" xml:space="preserve">
            <style type="text/css">
              .st0 {
                fill-rule: evenodd;
                clip-rule: evenodd;
                fill: #FFFFFF;
              }

              .st1 {
                fill-rule: evenodd;
                clip-rule: evenodd;
                fill: #1A1A1A;
              }
            </style>
            <g>
              <path class="st0"
                d="M25,0.87c13.33,0,24.13,10.8,24.13,24.13S38.33,49.13,25,49.13S0.87,38.33,0.87,25S11.67,0.87,25,0.87z" />
              <path class="st1" d="M25,8.37c1.13,0,2.05,0.92,2.05,2.07v23.94l8.81-8.87c0.8-0.81,2.11-0.81,2.91,0c0.8,0.81,0.8,2.12,0,2.93
          l-12.32,12.4c-0.8,0.81-2.1,0.81-2.9,0c0,0,0,0,0,0l-12.32-12.4c-0.8-0.81-0.8-2.12,0-2.93c0.8-0.81,2.11-0.81,2.91,0l8.81,8.87
          V10.43C22.95,9.29,23.87,8.37,25,8.37z" />
            </g>
          </svg>
        </a>
        <div class="keyboard" [class.on]="stitch?.hasFlag('keyboard')">
          <div class="letters">
            <div class="line" *ngFor="let line of lines">
              <div [class]="'letter letter_'+letter" *ngFor="let letter of line" (click)="onLetter(letter)"
                [innerHTML]="letter"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="answers" [ngStyle]="{ transform: 'translate(0,'+(countDown*200)+'px)' }">
        <ng-container *ngFor="let choice of stitch?.choices; let i = index;">
          <a *ngIf="choice.active || debug" [class]="'answer answer'+i" [class.on]="selected == i"
            [class.off]="!choice.active" [attr.data-selected]="selected" [attr.data-num]="i"
            (click)="onChoice(i, choice)">
            <ng-container *ngIf="choice.option != '+'">
              <!-- S'il y a un texte de choix -->
              <div [innerHTML]="choice.option"></div>
              <svg class="hand" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.09 44.28">
                <defs>
                  <style>
                    .cls-1 {
                      fill: #fff;
                    }
                  </style>
                </defs>
                <path class="cls-1"
                  d="M12.9,3.13A2.12,2.12,0,0,1,15.06,5.2V22.5a1.44,1.44,0,0,0,2.87,0v-7h.25a13.82,13.82,0,0,1,2.35.07,5.21,5.21,0,0,1,1.29.51.92.92,0,0,1,.43.87V22.5a1.44,1.44,0,0,0,2.87,0V18.17l.31,0a5.79,5.79,0,0,1,2,.11,4.64,4.64,0,0,1,1.4,1.19c.23.27.43.53.57.72v3.72a1.44,1.44,0,0,0,2.88,0V21.12h1a2.83,2.83,0,0,1,2.88,2.76,2.46,2.46,0,0,1,0,.28l-.78,7.51a6.78,6.78,0,0,1-.91,2.75l-4,6.75a1.44,1.44,0,0,1-1.25.7H10.85a1.46,1.46,0,0,1-1.2-.62l-4.12-6a4.1,4.1,0,0,1-.7-1.84l-1-8.59A1.39,1.39,0,0,1,5,23.36l2.88-.56v2.47a1.44,1.44,0,0,0,2.88,0V5.2A2.11,2.11,0,0,1,12.9,3.13Zm5,9.59V5.2a4.94,4.94,0,0,0-5-4.84,4.94,4.94,0,0,0-5,4.84V20l-3.45.67A4.17,4.17,0,0,0,1,25.17l1,8.6a6.63,6.63,0,0,0,1.16,3.07l4.12,5.95a4.38,4.38,0,0,0,3.59,1.85H29.2A4.36,4.36,0,0,0,33,42.55l4-6.76A9.6,9.6,0,0,0,38.24,32L39,24.43a5.58,5.58,0,0,0-5.15-6.05,5.44,5.44,0,0,0-.57,0H31.62c-.18-.24-.36-.46-.56-.69a7,7,0,0,0-2.53-2,8.43,8.43,0,0,0-3.33-.3l-.38,0a3.45,3.45,0,0,0-1.61-1.78,7.54,7.54,0,0,0-2.12-.8,14.52,14.52,0,0,0-3-.12Z"
                  transform="translate(-0.96 -0.36)" />
              </svg>
            </ng-container>
            <ng-container *ngIf="choice.option == '+' && choice.active">
              <!-- S'il ny a pas de texte pour le choix, et que le choix conditionnel est actif, on met une flèche -->
              <svg class="arrow" version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50"
                style="enable-background:new 0 0 50 50;" xml:space="preserve">
                <style type="text/css">
                  .st0 {
                    fill-rule: evenodd;
                    clip-rule: evenodd;
                    fill: #FFFFFF;
                  }

                  .st1 {
                    fill-rule: evenodd;
                    clip-rule: evenodd;
                    fill: #1A1A1A;
                  }
                </style>
                <g>
                  <path class="st0"
                    d="M25,0.87c13.33,0,24.13,10.8,24.13,24.13S38.33,49.13,25,49.13S0.87,38.33,0.87,25S11.67,0.87,25,0.87z" />
                  <path class="st1" d="M25,8.37c1.13,0,2.05,0.92,2.05,2.07v23.94l8.81-8.87c0.8-0.81,2.11-0.81,2.91,0c0.8,0.81,0.8,2.12,0,2.93
                l-12.32,12.4c-0.8,0.81-2.1,0.81-2.9,0c0,0,0,0,0,0l-12.32-12.4c-0.8-0.81-0.8-2.12,0-2.93c0.8-0.81,2.11-0.81,2.91,0l8.81,8.87
                V10.43C22.95,9.29,23.87,8.37,25,8.37z" />
                </g>
              </svg>
            </ng-container>
            <ng-container *ngIf="choice.option == '+' && (!choice.active && debug)">
              <!-- En mode debut, le choix inactif est symbolisé par une fleche barrée -->
              <svg class="arrow" version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50"
                style="enable-background:new 0 0 50 50;" xml:space="preserve">
                <style type="text/css">
                  .st0 {
                    fill-rule: evenodd;
                    clip-rule: evenodd;
                    fill: #FFFFFF;
                  }

                  .st1 {
                    fill-rule: evenodd;
                    clip-rule: evenodd;
                    fill: #1A1A1A;
                  }

                  .st2 {
                    fill: none;
                    stroke: #1A1A1A;
                    stroke-width: 4;
                    stroke-linecap: round;
                    stroke-miterlimit: 10;
                  }

                  .st3 {
                    fill: none;
                    stroke: #FFFFFF;
                    stroke-width: 4;
                    stroke-linecap: round;
                    stroke-miterlimit: 10;
                  }
                </style>
                <g>
                  <path class="st0"
                    d="M25,0.87c13.33,0,24.13,10.8,24.13,24.13S38.33,49.13,25,49.13S0.87,38.33,0.87,25S11.67,0.87,25,0.87z" />
                  <path class="st1" d="M25,8.37c1.13,0,2.05,0.92,2.05,2.07v23.94l8.81-8.87c0.8-0.81,2.11-0.81,2.91,0s0.8,2.12,0,2.93l-12.32,12.4
             c-0.8,0.81-2.1,0.81-2.9,0l0,0l-12.32-12.4c-0.8-0.81-0.8-2.12,0-2.93s2.11-0.81,2.91,0l8.81,8.87V10.43
             C22.95,9.29,23.87,8.37,25,8.37z" />
                </g>
                <line class="st2" x1="44.66" y1="6.38" x2="5.95" y2="45.09" />
                <line class="st3" x1="42.17" y1="3.89" x2="3.47" y2="42.6" />
              </svg>

            </ng-container>
          </a>
        </ng-container>
        <a *ngIf="stitch?.choices.length == 0" class="answer" [attr.data-selected]="selected" (click)="onEnd()">
          <!-- S'il n'y a pas de suite, c'est la fin. La flèche mènera aux conclusions. -->
          <svg class="arrow" version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50"
            style="enable-background:new 0 0 50 50;" xml:space="preserve">
            <style type="text/css">
              .st0 {
                fill-rule: evenodd;
                clip-rule: evenodd;
                fill: #FFFFFF;
              }

              .st1 {
                fill-rule: evenodd;
                clip-rule: evenodd;
                fill: #1A1A1A;
              }
            </style>
            <g>
              <path class="st0"
                d="M25,0.87c13.33,0,24.13,10.8,24.13,24.13S38.33,49.13,25,49.13S0.87,38.33,0.87,25S11.67,0.87,25,0.87z" />
              <path class="st1" d="M25,8.37c1.13,0,2.05,0.92,2.05,2.07v23.94l8.81-8.87c0.8-0.81,2.11-0.81,2.91,0c0.8,0.81,0.8,2.12,0,2.93
            l-12.32,12.4c-0.8,0.81-2.1,0.81-2.9,0c0,0,0,0,0,0l-12.32-12.4c-0.8-0.81-0.8-2.12,0-2.93c0.8-0.81,2.11-0.81,2.91,0l8.81,8.87
            V10.43C22.95,9.29,23.87,8.37,25,8.37z" />
            </g>
          </svg>
        </a>
      </div>

      <div class="color" [style.background-image]="image"></div>

      <div *ngIf="status == 'conclusions_splash' || status == 'conclusions'" class="conclusions">
        <div class="conclusion_splash" *ngIf="status == 'conclusions_splash'">
          <div class="title shadow" [innerHTML]="datas.langs[lang].conclusions_title"></div>
          <div *ngIf="datas?.langs[lang].conclusions[0]" class="link">
            <a (click)="playConclusion(0)" [style.background-image]="sanitized[0].style">
              <!-- <div class="duration" [innerHTML]="datas.langs[lang]?.conclusions[0].duration"></div> -->
              <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 6 7"
                style="enable-background:new 0 0 6 7;" xml:space="preserve">
                <style type="text/css">
                  .st0 {
                    fill: #FFFBFA;
                  }
                </style>
                <path class="st0" d="M1.54,0.59C1.32,0.43,1,0.49,0.84,0.71C0.78,0.79,0.75,0.9,0.75,1v5c0,0.28,0.22,0.5,0.5,0.5
           c0.1,0,0.21-0.03,0.29-0.09l3.5-2.5c0.22-0.16,0.28-0.47,0.12-0.7C5.12,3.16,5.09,3.13,5.04,3.09L1.54,0.59z" />
              </svg>
            </a>
          </div>
        </div>
        <div class="videos" *ngIf="status == 'conclusions'">
          <a class="cover0" (click)="playConclusion(conclusionIndex)"
            [style.background-image]="sanitized[conclusionIndex].style" *ngIf="conclusionIndex > 0">
          </a>
          <div id="video" *ngIf="currentVideo">
            <video #video autoplay (ended)="onVideoEnded($event)" [attr.loop]="loop ? 'loop' : null"
              [attr.poster]="sanitized[conclusionIndex].src" (click)="onVideoClick()" [muted]="mute">
              <source [src]="base+datasName+'/videos/'+currentVideo" type="video/mp4">
              <track *ngIf="webvtt" label="Français" kind="subtitles" srclang="fr" [src]="webvtt" default>
            </video>
            <div class="replay" (click)="onReplay()" *ngIf="videoProgress >= 100 || (paused && !dragging)">
              <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 6 7"
                style="enable-background:new 0 0 6 7;" xml:space="preserve">
                <style type="text/css">
                  .st0 {
                    fill: #FFFBFA;
                  }
                </style>
                <path class="st0" d="M1.54,0.59C1.32,0.43,1,0.49,0.84,0.71C0.78,0.79,0.75,0.9,0.75,1v5c0,0.28,0.22,0.5,0.5,0.5
          c0.1,0,0.21-0.03,0.29-0.09l3.5-2.5c0.22-0.16,0.28-0.47,0.12-0.7C5.12,3.16,5.09,3.13,5.04,3.09L1.54,0.59z" />
              </svg>
            </div>
            <div #progressBar class="progress" *ngIf="(videoProgress != 100 || dragging)">
              <div class="bar" [style.width]="videoProgress+'%'"></div>
              <div class="touch" [style.left]="videoProgress+'%'" (mousedown)="mousedown.next($event)"></div>
            </div>
          </div>
          <div class="links" [class.on]="(videoProgress >= 95 && !dragging) || conclusionMenu">
            <ng-container *ngFor="let conclusion of datas?.langs[lang].conclusions; let i = index;" class="link">
              <div class="link" [class.on]="i == conclusionIndex">
                <a (click)="playConclusion(i)" [style.background-image]="sanitized[i].style">
                  <div class="duration" [innerHTML]="conclusion.duration"></div>
                  <div class="title1" [innerHTML]="conclusion.title"></div>
                  <div class="title2" [innerHTML]="conclusion.title2"></div>
                  <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 6 7"
                    style="enable-background:new 0 0 6 7;" xml:space="preserve">
                    <style type="text/css">
                      .st0 {
                        fill: #FFFBFA;
                      }
                    </style>
                    <path class="st0"
                      d="M1.54,0.59C1.32,0.43,1,0.49,0.84,0.71C0.78,0.79,0.75,0.9,0.75,1v5c0,0.28,0.22,0.5,0.5,0.5
                c0.1,0,0.21-0.03,0.29-0.09l3.5-2.5c0.22-0.16,0.28-0.47,0.12-0.7C5.12,3.16,5.09,3.13,5.04,3.09L1.54,0.59z" />
                  </svg>
                </a>
              </div>
            </ng-container>
          </div>
          <div class="skip" (click)="onSkip()" [class.on]="!(videoProgress >= 95 || conclusionMenu) && !dragging">
            <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 15 15"
              style="enable-background:new 0 0 15 15;" xml:space="preserve">
              <style type="text/css">
                .st0 {
                  fill: #FFFFFF;
                }
              </style>
              <path class="st0"
                d="M9.08,10.4C8.61,10.68,8,10.34,8,9.78V8.5c0,0-4.5-0.5-7,4c1-8,5.5-8,7-8V3.22c0-0.13,0.03-0.25,0.1-0.36
           C8.3,2.51,8.74,2.4,9.08,2.6l4.57,3.28c0.1,0.06,0.19,0.15,0.25,0.25c0.2,0.34,0.09,0.78-0.25,0.98L9.08,10.4L9.08,10.4z" />
            </svg>
          </div>
          <div class="skip skip_close" (click)="onSkipClose()"
            [class.on]="(conclusionMenu && videoProgress <= 95) && !dragging">
            <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 15 15"
              style="enable-background:new 0 0 15 15;" xml:space="preserve">
              <style type="text/css">
                .st0 {
                  fill: #FFFFFF;
                }
              </style>
              <path class="st0" d="M3.75,3.75c0.22-0.22,0.57-0.22,0.79,0c0,0,0,0,0,0L7.5,6.71l2.96-2.96c0.22-0.22,0.57-0.22,0.79,0
           c0.22,0.22,0.22,0.57,0,0.79L8.29,7.5l2.96,2.96c0.22,0.22,0.22,0.57,0,0.79s-0.57,0.22-0.79,0L7.5,8.29l-2.96,2.96
           c-0.22,0.22-0.57,0.22-0.79,0c-0.22-0.22-0.22-0.57,0-0.79L6.71,7.5L3.75,4.54C3.53,4.32,3.53,3.96,3.75,3.75
           C3.74,3.75,3.74,3.75,3.75,3.75z" />
            </svg>
          </div>
        </div>
      </div>
      <div class="generalBtns">
        <a class="homeBtn" (click)="onBtnHome()" *ngIf="started">
          <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
            <style type="text/css">
              .st0 {
                fill-rule: evenodd;
                clip-rule: evenodd;
                fill: #FFFFFF;
              }
            </style>
            <polygon class="st0" points="2.4,7.2 8,1.6 13.4,7.1 13.4,14.3 2.4,14.3 " />
            <path class="st0" d="M2,13.5V7h1v6.5C3,13.8,3.2,14,3.5,14h9c0.3,0,0.5-0.2,0.5-0.5V7h1v6.5c0,0.8-0.7,1.5-1.5,1.5h-9
         C2.7,15,2,14.3,2,13.5z" />
            <path class="st0" d="M7.3,1.5c0.4-0.4,1-0.4,1.4,0l6.6,6.6c0.2,0.2,0.2,0.5,0,0.7s-0.5,0.2-0.7,0L8,2.2L1.4,8.9C1.2,9,0.8,9,0.6,8.9
         s-0.2-0.5,0-0.7L7.3,1.5z" />
          </svg>
        </a>
        <a *ngIf="!kiosk" class="wideBtn" (click)="onBtnWide()">
          <svg *ngIf="!wide" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-fullscreen"
            viewBox="0 0 16 16">
            <path
              d="M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z" />
          </svg>
          <svg *ngIf="wide" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-fullscreen-exit"
            viewBox="0 0 16 16">
            <path
              d="M5.5 0a.5.5 0 0 1 .5.5v4A1.5 1.5 0 0 1 4.5 6h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 10 4.5v-4a.5.5 0 0 1 .5-.5zM0 10.5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 6 11.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zm10 1a1.5 1.5 0 0 1 1.5-1.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4z" />
          </svg>
        </a>
        <a *ngIf="!kiosk" class="muteBtn" (click)="onBtnMute()">
          <svg *ngIf="mute" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-volume-mute"
            viewBox="0 0 16 16">
            <path
              d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zM6 5.04 4.312 6.39A.5.5 0 0 1 4 6.5H2v3h2a.5.5 0 0 1 .312.11L6 10.96V5.04zm7.854.606a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0z" />
          </svg>
          <svg *ngIf="!mute" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-volume-up"
            viewBox="0 0 16 16">
            <path
              d="M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z" />
            <path
              d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z" />
            <path
              d="M10.025 8a4.486 4.486 0 0 1-1.318 3.182L8 10.475A3.489 3.489 0 0 0 9.025 8c0-.966-.392-1.841-1.025-2.475l.707-.707A4.486 4.486 0 0 1 10.025 8zM7 4a.5.5 0 0 0-.812-.39L3.825 5.5H1.5A.5.5 0 0 0 1 6v4a.5.5 0 0 0 .5.5h2.325l2.363 1.89A.5.5 0 0 0 7 12V4zM4.312 6.39 6 5.04v5.92L4.312 9.61A.5.5 0 0 0 4 9.5H2v-3h2a.5.5 0 0 0 .312-.11z" />
          </svg>
        </a>
      </div>
      <a *ngIf="!kiosk" class="creditsBtn" (click)="onCredits()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
          <path
            d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
        </svg>
      </a>
      <div class="homeQuestion" *ngIf="homeQuestion">
        <div class="overlay" (click)="onHomeQuestion(false)"></div>
        <div class="popin">
          <div class="inner" *ngIf="lang == 0">
            <div class="text">Voulez-vous vraiment<br>
              recommencer l’aventure<br>
              depuis le début ?</div>
            <div class="btns">
              <a (click)="onHomeQuestion(true)">Oui</a>
              <a (click)="onHomeQuestion(false)">Non</a>
            </div>
          </div>
          <div class="inner" *ngIf="lang == 1">
            <div class="text">Do you really want<br>
              to go back to the start<br>
              of the adventure?</div>
            <div class="btns">
              <a (click)="onHomeQuestion(true)">Yes</a>
              <a (click)="onHomeQuestion(false)">No</a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div *ngIf="credits " class="credits">
  <div class="content">
    <p>
      <svg (click)="onCreditsClose()" xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor"
        class="bi bi-x-circle" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
      </svg>
    </p>
    <p>
      Là-haut est un jeu du Mémorial de la Résistance en Vercors.<br> Là-haut propose aux visiteurs de se mettre dans
      la peau d'un citoyen en temps d'occupation.<br>
      <a href="https://parc-du-vercors.fr/resistance/sengager-un-jeu-pour-se-mettre-dans-la-peau-dun-citoyen-en-temps-doccupation"
        target="_blank">En savoir plus</a>
    </p>
    <p>
      Conception : <a href="https://www.superexpose.fr" target="_blank">Superexpose</a><br>
      Design : <a href="https://www.superexpose.fr" target="_blank">Superexpose</a><br>
      Création sonore : <a target="_blank">Guilhem Lacroux</a><br>
      Rédaction : <a href="mailto:normartin@sfr.fr" target="_blank">Norbert Martin</a><br>
      Philosophie : <a href="mailto:christophewelcker@gmail.com" target="_blank">Christophe Welcker</a><br>
      Vidéo : <a href="https://www.fertil-ink.com/" target="_blank">Fertil Ink</a><br>
      Développement : <a href="https://www.superexpose.fr" target="_blank">Superexpose</a><br>
    </p>
  </div>
</div>

<!-- dev -->
<ng-container *ngIf="!export && debug">
  <div class="effects">
    <div *ngFor="let effect of datasdev?.effects" class="effect" (click)="onEffect(effect)" [innerHTML]="effect.id">
    </div>
    &nbsp;
  </div>
  <div class="stitches">
    <ng-container *ngFor="let s of story?.stitchesArray">
      <div *ngIf="s.isMenu()" class="stitch pageLabel" (click)="onStitch(s)" [innerHTML]="s.getMenu()"></div>
    </ng-container>
    <!-- <ng-container *ngFor="let s of story?.stitchesArray">
      <div *ngIf="s.pageLabel" class="stitch pageLabel" (click)="onStitch(s)" [innerHTML]="s.pageLabel">
      </div>
    </ng-container> -->
    <div *ngFor="let s of story?.stitchesArray" class="stitch" (click)="onStitch(s)" [innerHTML]="s.path"
      [class.on]="stitch && s.path == stitch.path"></div>
  </div>
  <div class="debug">
    <div class="stitch" [innerHTML]="stitch?.path"></div>
    <div class="flags">
      <span *ngFor="let flag of story?.flags.flags">{{flag.label}}<span
          *ngIf="flag.value !== true">:{{flag.value}}</span></span>
    </div>
    <div class="ips">{{ips}}</div>
  </div>
</ng-container>

<!-- export=1 -->
<div id="export" *ngIf="export && datas">
  <div class="list">
    <div *ngFor="let s of story?.stitchesArray" class="export_stitch" (click)="onStitch(s)" [id]="s.path">
      ---------------------------------------------------
      <div [innerHTML]="s.path" class="path"></div>
      <div [innerHTML]="s?.text"></div>
      <div class="export_answers">
        <ng-container *ngFor="let choice of s.choices; let i = index;">
          <a class="export_answer" [href]="currentUrl+'#'+choice.linkPath">
            <ng-container *ngIf="choice.option != '+'">
              <div [innerHTML]="choice.option"></div>
            </ng-container>
            <ng-container *ngIf="choice.option == '+'">
              <div>>>></div>
            </ng-container>
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>